import { useEffect, useState } from 'react';
import ContainerComponent from '@/components/common/notes/show-note-forms/form-components/container-component';
import { SET_VALUE } from '@/components/common/notes/show-note-forms/dataToSendReducer';
import { Checkbox, FormControl, FormControlLabel, FormGroup } from '@mui/material';
import decodeHtmlEntities from '@/utils/decodeHtmlEntities';

interface Props {
    value: any;
    formId: string;
    formName: string;
    formDispatch: any;
    item: {
        label: string;
        name: string;
        placeholder: string;
        subtype: string;
        required: boolean;
        values: any[];
        description: string;
    };
    readOnly: boolean;
}

const CheckboxFieldComponent = ({
    value,
    formDispatch,
    formId,
    formName,
    item: { label, values, name: fieldId, required, description },
    readOnly,
}: Props) => {
    const convertValues = (
        values: {
            label: string;
            selected: boolean;
            value: string;
        }[],
    ) => {
        let out: { [key: string]: boolean } = {};
        values.map((item) => (out[item.value] = item.selected));
        return out;
    };

    const [convertedValues, setConvertedValues] = useState(value ? value : convertValues(values));

    useEffect(() => {
        formDispatch({
            type: SET_VALUE,
            payload: { value: convertedValues, fieldId, formId },
        });
        formDispatch({
            type: SET_VALUE,
            payload: { value: convertedValues, fieldId, formId: formName },
        });
    }, [convertedValues]);

    const handleChange = ({ target: { name, checked } }: any) => {
        let newConvertedValues = { ...convertedValues };
        newConvertedValues[name] = checked;
        setConvertedValues(newConvertedValues);
    };

    return (
        <ContainerComponent label={label} required={required} description={description}>
            <FormControl component='fieldset'>
                <FormGroup>
                    {values.map(({ label, value: value_ }) => (
                        <FormControlLabel
                            key={label}
                            control={
                                <Checkbox
                                    checked={value ? value[value_] : false}
                                    onChange={handleChange}
                                    name={value_}
                                    color={'primary'}
                                />
                            }
                            label={decodeHtmlEntities(label)}
                            sx={{ '& .MuiFormControlLabel-label': { fontSize: 14 } }}
                            disabled={readOnly}
                        />
                    ))}
                </FormGroup>
            </FormControl>
        </ContainerComponent>
    );
};

export default CheckboxFieldComponent;
